export * from './components/Persona/index';
//# sourceMappingURL=Persona.js.map